module.exports={
    "selectLocation": "Click and add a pin to map",
    "defaultLocationName": "Custom pin"
}
